import {intlShape, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';
import {FileDownload} from 'src/js/containers/file/components/FileDownload';
import {File as FileModel} from 'src/js/model/file';

import styles from './FileDownloadFormatter.less';

const I18N = defineMessages({
  DOWNLOAD: {
    id: 'common.fileDownload',
    defaultMessage: 'Download file {file}',
    description: 'title text for file download button',
  },
});

class FileDownloadFormatter extends React.PureComponent {
  render() {
    const {intl, value} = this.props;
    return value ? (
      <div className={styles.dlFileDownloadFormatter}>
        <FileDownload
          downloadUrl={FileModel.createDownloadUrl(value.config, value.blobId)}
          titleText={utils.TranslateUtils.translate(I18N.DOWNLOAD, intl, {
            file: value.blobId,
          })}
        >
          {value.blobId} <i className={'fas fa-download'} />
        </FileDownload>
      </div>
    ) : (
      ''
    );
  }
}

FileDownloadFormatter.displayName = 'FileDownloadFormatter';

FileDownloadFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.objectOf(PropTypes.any),
};

FileDownloadFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(FileDownloadFormatter);
